import { DeleteOutlined, EditOutlined, MoreOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs"
import { useSelector } from "react-redux";
import TableAntd from "components/elements/Table/Table";

const EmployeeInfoFalmilyTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
}) => {

  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const columns = [
    {
      title: (
        <div className="text-table">{t("common.index")}</div>
      ),
      dataIndex: "id",
      key: "id",
      width: 80,
      render: (text, record, index) => {
        return (
          <span
            style={{
              color: "#313131",
              backgroundColor: "#F5F6F7",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            {index + 1}
          </span>)
      }
    },

    {
      title: <div className="text-table">{t('employee.name-0')}</div>,
      dataIndex: "fullName",
      key: "fullName",
      // sorter: (a, b) => a.fullName?.name?.length - b.fullName?.name?.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return <span style={{ color: "#42526D" }}>{record?.fullName}</span>;
        }
        return <span style={{ color: "#42526D" }}>{record?.fullName}</span>;
      },
    },
    {
      title: <div className="text-table">{t('employee.relationship')}</div>,
      dataIndex: "relationship",
      key: "relationship",
      // sorter: (a, b) => a.relationship.name.length - b.relationship.name.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return <span style={{ color: "#42526D" }}>{record?.relationship?.nameEn}</span>;
        }
        return <span style={{ color: "#42526D" }}>{record?.relationship?.name}</span>;
      },
    },
    {
      title: <div className="text-table">{t('employee.date-of-birth')}</div>,
      dataIndex: "dateOfBirth",
      key: "dateOfBirth",
      render: (_, record) => {
        return <span style={{ color: "#42526D" }}>{record?.dateOfBirth ? formatDate(record?.dateOfBirth) : "-"}</span>
      }
    },
    {
      title: <div className="text-table">{t('employee.occupation')}</div>,
      dataIndex: "career",
      key: "career",
      // sorter: (a, b) => a.career?.name?.length - b.career?.name?.length,
      render: (_, record) => {
        if (i18n.language === "en") {
          return <span style={{ color: "#313131" }}>{record?.career ? record?.career?.nameEn : "-"}</span>;
        }
        return <span style={{ color: "#313131" }}>{record?.career ? record?.career?.name : "-"}</span>;
      },
    },

    {
      title: <div className="text-table">{t('signup.input.phoneNo')}</div>,
      dataIndex: "mobileNumber",
      key: "mobileNumber",
      // sorter: (a, b) => a.mobileNumber?.name?.length - b.mobileNumber?.name?.length,
      render: (_, record) => {
        return <span style={{ color: "#313131" }}>{record?.mobileNumber ? record?.mobileNumber.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3") : "-"}</span>;
      },
    },

    roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|FAMILY")
      || roles.includes("DELETE_EMPLOYEE|EMPLOYEE_INFO|FAMILY") ? {
      title: "",
      key: "action",
      align: "center",
      width: "5%",
      render: (_, record) => (
        <Space size="middle">
          <Dropdown
            menu={{
              items: [
                roles.includes("UPDATE_EMPLOYEE|EMPLOYEE_INFO|FAMILY") && {
                  key: "1",
                  onClick: () => onEdit(record),
                  label: `${t("action.edit")}`,
                  icon: (
                    <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
                roles.includes("DELETE_EMPLOYEE|EMPLOYEE_INFO|FAMILY") && {
                  key: "2",
                  onClick: () => onDelete(record),
                  label: `${t("action.delete")}`,
                  icon: (
                    <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                  ),
                },
              ],
            }}
          >
            <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
          </Dropdown>
        </Space>
      ),
    } : {},
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeInfoFalmilyTable;
